import { createReducer } from 'AppSrc/core/reducers/create-reducer';
import { REFRESH_POU_ERROR, REFRESH_POU_REQUEST, REFRESH_POU_SUCCESS } from './pou-actions';

const defaultState = {
  refreshingPou: false,
};

const setRefreshingPou = (refreshingPou) => (state, action) => ({
  refreshingPou,
});

const actionHandlers = {
  [REFRESH_POU_REQUEST]: setRefreshingPou(true),
  [REFRESH_POU_ERROR]: setRefreshingPou(false),
  [REFRESH_POU_SUCCESS]: setRefreshingPou(false),
};

const pouReducer = createReducer(defaultState, actionHandlers);

export {
  pouReducer,
  defaultState,
};
